.select-picker-label {
    position: relative;
    display: inline-block;
}

/* This makes the <select> element invisible and positioned over the label */
.invisible-select {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    z-index: 1;
}

.invisible-select:disabled {
    cursor: default;
}

.disabled {
    opacity: 0.6;
}
